module.exports = __webpack_public_path__ + "static/img/preview.7ccf31e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/taco-recombinator/preview.jpg
// module id = nFlW
// module chunks = 1